var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "position-relative fancy-text-box" },
    [
      _c("div", { staticClass: "tools" }, [
        _c("div", { staticClass: "tool" }, [
          _c(
            "a",
            {
              attrs: { href: "javascript:;" },
              on: {
                click: function($event) {
                  return _vm.toolClick("emoji")
                }
              }
            },
            [_c("i", { staticClass: "fa fa-smile-o" })]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tool" }, [
          _c(
            "a",
            {
              attrs: { href: "javascript:;" },
              on: {
                click: function($event) {
                  return _vm.toolClick("upload")
                }
              }
            },
            [_c("i", { staticClass: "fa fa-upload" })]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tool" }, [
          _c(
            "a",
            {
              attrs: { href: "javascript:;" },
              on: {
                click: function($event) {
                  return _vm.toolClick("send")
                }
              }
            },
            [_c("i", { staticClass: "fa fa-send" })]
          )
        ])
      ]),
      _vm._v(" "),
      _c("quill", {
        ref: "quill-editor",
        staticClass: "form-control",
        staticStyle: { width: "100%", height: "75px", "padding-right": "65px" },
        attrs: {
          mentionSearchFunction: _vm.mentionSearchFunction,
          enterIsSend: true,
          disabled: _vm.disabled
        },
        on: { keydown: _vm.keydownEvent },
        model: {
          value: _vm.editorValue,
          callback: function($$v) {
            _vm.editorValue = $$v
          },
          expression: "editorValue"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }